var snapscroll = function () {
  if( $(window).width() < 490 ) {
    znapscroll.prepare();
  } else {
    //reset size from scrollsnap
    $('.product-photo-thumb').each(function() {
      $(this).css('width',' ');
    });
    $('.product-thumbs').css({ "overflow": "auto", "width": " " });
    $('.navbar, #maincontainer').css("margin-left", ' ');
    $('.navbar, #maincontainer').css("margin-right", ' ');
  }
}

var formatForScreen = function(){

  snapscroll();

  if($(window).width() < 769){

    $('header .navbar, #maincontainer, footer').css({
      'margin-left' : '0',
      'margin-right' : '0'
    })

    if($(window).width() < 480 ) {
      $('.product-thumbs').width( size = $('.product-thumbs img').length + '00vw' );
    }

    $('body').css('overflow-x','hidden');
    $('.swatches-wrapper').css('margin-right','auto');

  } else {
    $('body').css('overflow','auto');
  }

  $('.product-thumbs .zoom').each(function(){
    img = $(this).next('img')
    $(this).css('width', img.width())
  })

}

// This handles sizing the image list so that it scrolls properly

$(window).on('resize',function(){
  formatForScreen();
});

$(window).on('load',function(){
  formatForScreen();
});

$(document).ready(function(){
  formatForScreen();

  $('.product-thumbs .zoom').on('click', function(e){
    zoom = $(this);

    if(zoom.hasClass('on')){
      zoom.removeClass('on');
    } else {
      src = zoom.data('lrg');
      img = zoom.next('img');

      zoom.css('width', img.width());
      zoom.html('<img class="panImage" src="' + src + '">');

      panImage = zoom.find('.panImage');
      panImage.on('load', function(){
        setZoomPosition(e, zoom);
        zoom.addClass('on');
      })
    }
  });

  $('.product-thumbs .zoom').on('mousemove', function(e){
    scrX = $(window).scrollTop();
    scrY = $(window).scrollLeft();

    zoom = $(this);
    setZoomPosition(e, zoom);
  });

  var setZoomPosition = function(e, zoom){
    panImage = zoom.find('img');

    mouseX = e.pageX - (zoom.offset().left);
    mouseY = e.pageY - (zoom.offset().top);
    ratioX = mouseX / zoom.width();
    ratioY = mouseY / zoom.height();

    offsetX = -(zoom.width() * ratioX);
    offsetY = -(zoom.height() * ratioY);

    panImage.css({
      'margin-top': offsetY + "px",
      'margin-left': offsetX + "px"
    });
  }

  // SWATCHES

  $('.soldout input:checked:first').parents('.swatch-element').next('.available').find('label').click()
})
